import { Box } from '@chakra-ui/react';
import { BaseOption } from '@/shared/ui/OptionSelector';

interface ColorOption extends BaseOption {
  label: string;
  hex: string;
}

interface ColorOptionCardProps {
  option: ColorOption;
  isSelected: boolean;
}

const ColorOptionCard = ({ option }: ColorOptionCardProps) => {
  const { hex } = option;

  return (
    <Box
      bgColor={hex}
      borderRadius='sm'
      h='full'
      w='full'
    />
  );
};

export type { ColorOption };
export default ColorOptionCard;
